import { inject, Injectable } from '@angular/core';
import { type ActivatedRouteSnapshot, Router, type UrlTree } from '@angular/router';
import { stripLanguageFromUrl } from '@reconcept-platform/shared/util';
import { type Observable } from 'rxjs';
import { AuthApiService } from './auth.api';

@Injectable({
  providedIn: 'root',
})
export class RedirectFromParamsGuard {
  private authApi = inject(AuthApiService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const returnState = route.queryParams['state'];

    if (returnState) {
      const deepLink = this.authApi.decodeState(returnState);

      const isPRUri = deepLink.match(/^\/(\d+)\//);

      if (isPRUri) {
        const prUri = isPRUri[0];

        this.router.navigateByUrl(deepLink.replace(prUri, ''));
      }

      const languageUri = stripLanguageFromUrl(deepLink);
      if (languageUri !== deepLink) {
        this.router.navigateByUrl(languageUri);
      }
      return false;
    }

    return true;
  }
}
